/* Product card swatches: hovering a stone/metal option previews its image in the card */
(function () {
  'use strict';

  function bind(root) {
    root.querySelectorAll('[data-product-card]').forEach(function (card) {
      if (card.dataset.swatchReady) return;
      card.dataset.swatchReady = 'true';

      const img = card.querySelector('.product-card__img--primary');
      const swatches = card.querySelectorAll('[data-swatch-src]');
      if (!img || !swatches.length) return;

      const original = { src: img.src, srcset: img.getAttribute('srcset') || '' };

      swatches.forEach(function (swatch) {
        function preview() {
          img.srcset = swatch.dataset.swatchSrcset || '';
          img.src = swatch.dataset.swatchSrc;
          card.classList.add('is-swatch-preview');
          swatches.forEach(function (s) { s.classList.toggle('is-active', s === swatch); });
        }
        swatch.addEventListener('mouseenter', preview);
        swatch.addEventListener('focus', preview);
      });

      card.addEventListener('mouseleave', function () {
        img.srcset = original.srcset;
        img.src = original.src;
        card.classList.remove('is-swatch-preview');
        swatches.forEach(function (s) { s.classList.remove('is-active'); });
      });
    });
  }

  window.LenoraProductCards = { bind: bind };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
